import React, { useEffect, useState } from 'react'; 
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Spin, message } from 'antd';
import useScreenType from 'react-screentype-hook';
import UploadData from './modaltraining/uploaddata';
import Annotation from './modaltraining/annotation';
import ViewAnnotation from './modaltraining/viewannotation';
import ExportAnnotation from './modaltraining/exportannotation';
import Annalytics from './modaltraining/annalytics';
import Datasetversion from './modaltraining/datasetversion';
import Viewdatasetversion from './modaltraining/viewdatasetversion';
import { FileTextOutlined, UploadOutlined, HighlightOutlined, ExportOutlined, BarChartOutlined, ClusterOutlined, BranchesOutlined, LockOutlined } from '@ant-design/icons';
import { ArrowLeftCircle, LayoutDashboard } from "lucide-react";
import { GoWorkflow } from "react-icons/go";
import Workflow from './workflow/workflow';
import Dataflow from './Dataflow/dataflow';
import PrivateRoute from '../layouts/PrivateRoute';
// import DashboardBuilder from './modaltraining/dragdrop/dragdrop';
import Header from './header/header2';

const { Content, Sider } = Layout;

const Sidebar = ({ path }) => {
    const location = useLocation();
    const projectname = location.state?.projectname || localStorage.getItem("projectname") || "";
    const [selectedMenu, setSelectedMenu] = useState([`${path}/create-project`]);
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const screenType = useScreenType();
    const navigate = useNavigate();

    const citriot = JSON.parse(localStorage.getItem("citriot"));
    const user = JSON.parse(localStorage.getItem("user")) || {};

    function getItem(label, key, icon) {

        const isLocked =
            user?.subscribe === false && !key.includes("Dataflow");

        return {
            key,
            icon,
            label: (
            <div className="flex items-center justify-between">
                <span>{label}</span>
                {isLocked && <LockOutlined style={{ fontSize: 12, opacity: 0.7 }} />}
            </div>
            ),
            className: isLocked ? "opacity-60 cursor-not-allowed" : ""
        };
    }

    // useEffect(() => {
    //     const getOrganisations = async () => {
    //         try {
    //             setLoading(true);
    //             const tempItems = [];

    //             // 🧠 Full pipeline for scratch model
    //             tempItems.push(
    //                 getItem('Upload Data', `${path}/UploadData`, <UploadOutlined />),
    //                 getItem('Data Set', `${path}/ViewAnnotation`, <HighlightOutlined />),
    //                 getItem('View DataSet Version', `${path}/Viewdatasetversion`, <ClusterOutlined />),
    //                 // getItem('Export Annotation', `${path}/ExportAnnotation`, <ExportOutlined />),
    //                 getItem('Analytics', `${path}/Annalytics`, <BarChartOutlined />),
    //                 getItem('Dataflow', `${path}/Dataflow`, <BranchesOutlined />),
    //                 getItem(
    //                 'Dashboard Setting',
    //                 `${path}/Dashboard-Setting`,
    //                 <LayoutDashboard size={18} />
    //                 ),
    //                 getItem('Workflow', `${path}/Workflow`, <GoWorkflow />)
    //             );
    //             setItems(tempItems);
    //             setLoading(false);
    //         } catch (err) {
    //             setLoading(false);
    //             message.error(err.response?.data?.msg || 'Something went wrong');
    //         }
    //     };
    //     getOrganisations();
    //     const currentPath = window.location.pathname;
    //      if (currentPath === '/sidebar') {
    //         navigate(`${path}/UploadData`, { state: { projectname: projectname } });
    //         setSelectedMenu([`${path}/UploadData`]);
    //     } else {
    //         setSelectedMenu([currentPath]);
    //     }
    // }, [path, navigate]);

    useEffect(() => {
        const getOrganisations = async () => {
            try {
                setLoading(true);
                // if (user?.subscribe === false) {
                //     // 🔒 Only allowed pages for non-subscribed users
                //     tempItems.push(
                //         getItem('Dataflow', `${path}/Dataflow`, <BranchesOutlined />),
                //         // getItem(
                //         //     'Dashboard Setting',
                //         //     `${path}/Dashboard-Setting`,
                //         //     <LayoutDashboard size={18} />
                //         // )
                //     );
                // } else {
                //     // ✅ Full access for subscribed users
                //     tempItems.push(
                //         getItem('Upload Data', `${path}/UploadData`, <UploadOutlined />),
                //         getItem('Data Set', `${path}/ViewAnnotation`, <HighlightOutlined />),
                //         getItem('View DataSet Version', `${path}/Viewdatasetversion`, <ClusterOutlined />),
                //         getItem('Analytics', `${path}/Annalytics`, <BarChartOutlined />),
                //         getItem('Dataflow', `${path}/Dataflow`, <BranchesOutlined />),
                //         // getItem(
                //         //     'Dashboard Setting',
                //         //     `${path}/Dashboard-Setting`,
                //         //     <LayoutDashboard size={18} />
                //         // ),
                //         getItem('Workflow', `${path}/Workflow`, <GoWorkflow />)
                //     );
                // }
                const tempItems = [
                    getItem('Upload Data', `${path}/UploadData`, <UploadOutlined />),
                    getItem('Data Set', `${path}/ViewAnnotation`, <HighlightOutlined />),
                    getItem('View DataSet Version', `${path}/Viewdatasetversion`, <ClusterOutlined />),
                    getItem('Analytics', `${path}/Annalytics`, <BarChartOutlined />),
                    getItem('Dataflow', `${path}/Dataflow`, <BranchesOutlined />),
                    getItem('Workflow', `${path}/Workflow`, <GoWorkflow />)
                ];
                setItems(tempItems);
                setItems(tempItems);
                setLoading(false);

            } catch (err) {
                setLoading(false);
                message.error(err.response?.data?.msg || 'Something went wrong');
            }
        };

        getOrganisations();

        const currentPath = window.location.pathname;

        if (currentPath === '/sidebar') {
            if (user?.subscribe === false) {
                navigate(`${path}/Dataflow`);
                setSelectedMenu([`${path}/Dataflow`]);
            } else {
                navigate(`${path}/UploadData`);
                setSelectedMenu([`${path}/UploadData`]);
            }
        } else {
            setSelectedMenu([currentPath]);
        }

    }, [path, navigate]);

    return (
        <>
            {loading ? (
            <Spin />
            ) : (
            <Layout style={{ minHeight: "100vh" }}>
                
                {/* ✅ HEADER AT TOP */}
                <Header auth={citriot?.auth} />

                {/* ✅ SIDEBAR + CONTENT BELOW HEADER */}
                <Layout hasSider>
                
                <Sider
                    collapsed={!isHovered}
                    breakpoint="lg"
                    width={screenType.isMobile ? 150 : 220}
                    collapsedWidth={screenType.isMobile ? 60 : 80}
                    theme="dark"
                    className="bg-gray-800"
                    style={{
                    position: "fixed",
                    top: 68,                 // ✅ Start BELOW header
                    left: 0,
                    bottom: 0,
                    overflowY: "auto",
                    transition: "all 0.2s",
                    backgroundColor: "#1f2937",
                    }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <div
                    className="flex items-center justify-center py-4 cursor-pointer hover:bg-gray-700 transition"
                    onClick={() => navigate("/selectmodel")}
                    style={{ color: "white", fontSize: "20px" }}
                    >
                    <ArrowLeftCircle style={{ fontSize: "22px", color: "#38bdf8" }} />
                    </div>

                    <Menu
                    className="h-full border-r-0 itemBoss"
                    mode="inline"
                    selectedKeys={selectedMenu}
                    onSelect={({ key }) => {
                        if (key.includes("Dataflow")) {
                            navigate(key);
                            setSelectedMenu([key]);
                            return;
                        }
                        if (user?.subscribe === false) {
                            message.warning("Please subscribe to access this feature");
                            return;
                        }
                        navigate(key);
                        setSelectedMenu([key]);
                    }}
                    items={items}
                    theme="dark"
                    style={{
                        backgroundColor: "#1f2937",
                        color: "white",
                    }}
                    />
                </Sider>

                {/* ✅ CONTENT ADJUSTED */}
                <Layout
    style={{
        marginLeft:
            screenType.isMobile
                ? isHovered
                    ? 150
                    : 60
                : isHovered
                ? 220
                : 80,
        transition: "all 0.2s",
    }}
>

                    <Content className="bg-white" style={{ padding: "16px" }}>
                    <Routes>
                        <Route path="UploadData" element={<PrivateRoute><UploadData /></PrivateRoute>} />
                        <Route path="Annotation" element={<PrivateRoute><Annotation /></PrivateRoute>} />
                        <Route path="ViewAnnotation" element={<PrivateRoute><ViewAnnotation /></PrivateRoute>} />
                        <Route path="ExportAnnotation" element={<PrivateRoute><ExportAnnotation /></PrivateRoute>} />
                        <Route path="Annalytics" element={<PrivateRoute><Annalytics /></PrivateRoute>} />
                        <Route path="Datasetversion" element={<PrivateRoute><Datasetversion /></PrivateRoute>} />
                        <Route path="Viewdatasetversion" element={<PrivateRoute><Viewdatasetversion /></PrivateRoute>} />
                        <Route path="Workflow" element={<PrivateRoute><Workflow /></PrivateRoute>} />
                        <Route path="Dataflow" element={<PrivateRoute><Dataflow /></PrivateRoute>} />
                        {/* <Route path="Dashboard-Setting" element={<PrivateRoute><DashboardBuilder /></PrivateRoute>} /> */}
                    </Routes>
                    </Content>
                </Layout>
                </Layout>
            </Layout>
            )}
        </>
    );
};

export default Sidebar;